const organizationTypes = Object.freeze({ PERSONAL: 'Личное', TEAM: 'Агентство' })
const membershipRoles = Object.freeze({ OWNER: 'Владелец', ADMIN: 'Администратор', MEMBER: 'Агент' })
const invitationStates = Object.freeze({ PENDING: 'Ожидает ответа', ACCEPTED: 'Принято', REVOKED: 'Отозвано', EXPIRED: 'Истекло', DECLINED: 'Отклонено' })
const membershipStates = Object.freeze({ ACTIVE: 'Активен', INACTIVE: 'Неактивен', DISABLED: 'Отключён' })

function label(map, value, fallback) {
	return map[value] || fallback
}

export const organizationTypeLabel = value => label(organizationTypes, value, 'Неизвестный тип организации')
export const membershipRoleLabel = value => label(membershipRoles, value, 'Неизвестная роль')
export const invitationStatusLabel = value => label(invitationStates, value, 'Неизвестный статус приглашения')
export const membershipStatusLabel = value => label(membershipStates, value, 'Неизвестный статус участия')
